/* eslint-disable @next/next/no-img-element */
import React, {useEffect, useRef, useState} from 'react';
import {Tabs, Button, Tooltip} from 'antd';
import styles from './style.module.scss';
import {EditorState} from 'draft-js';
import classNames from 'classnames';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileImage} from '@fortawesome/pro-light-svg-icons';
import {BrowseImage} from './browseFile';
import {UploadURL} from './urlUpload';

interface Props {
  updateText: (state: EditorState) => void;
  editorState: any;
}

export const UploadImage = observer(({updateText, editorState}: Props) => {
  const {
    contentOptimizer: {
      currentPage: {currentEditorState},
    },
  } = useStore('');
  const [showNewUrlEditor, setShowNewUrlEditor] = useState(false);
  const dateRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dateRef.current &&
        !dateRef.current.parentElement.contains(event.target)
      ) {
        setShowNewUrlEditor(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dateRef]);


  const iconClicked = (e?: any) => {
    e.preventDefault();
    setShowNewUrlEditor(true);
  };

  const ele = document.getElementById('numberHeight');
  ele?.addEventListener('keydown', function(e) {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 69 || keyCode === 187 || keyCode === 189) {
      e.preventDefault();
    }
  });

  return (
    <div className={styles['header-toolkit']} style={{position: 'relative'}}>
      <Tooltip title='Upload Image'>
        <FileBtn
          type='text'
          ref={dateRef}
          onMouseDown={(e: any) => iconClicked(e)}
          className={classNames(styles.button, {
            [styles.active]: currentEditorState
              .getCurrentInlineStyle()
              .toJS()
              .includes('LINK'),
          })}
        >
          <FontAwesomeIcon icon={faFileImage} />
        </FileBtn>
      </Tooltip>
      {showNewUrlEditor && (
        <Popup className={styles.urlPopup}>
          <StyledInputContainer className={styles.inputContainer}>
            <p className={styles.textLabel}>Upload image</p>
            <StyledTabs defaultActiveKey='url'>
              <Tabs.TabPane tab='From URL' key='url'>
                <UploadURL setShowNewUrlEditor={setShowNewUrlEditor} updateText={updateText} editorState={editorState}/>
              </Tabs.TabPane>
              <Tabs.TabPane tab='Browse file' key='file'>
                <BrowseImage setShowNewUrlEditor={setShowNewUrlEditor} updateText={updateText} editorState={editorState} />
              </Tabs.TabPane>
            </StyledTabs>
          </StyledInputContainer>
        </Popup>
      )}
    </div>
  );
});

const FileBtn = styled(Button)`
  padding: 4px 6px 6px 6px;
  svg {
    height: 17px;
    color: gray;
  }
`;


const StyledTabs = styled(Tabs)`
  .ant-tabs-ink-bar {
    background: rgba(45, 108, 202, 1); 
    height: 5px !important;
    border-radius: 3px 3px 0px 0px;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: rgba(18, 18, 18, 1);
  }
  .ant-tabs-tab:hover {
    color: rgba(18, 18, 18, 1);
  }
  .ant-tabs-nav{
    margin-bottom: 5px !important;
  }
`;
const StyledInputContainer = styled.div`
  .cloudIcon {
    height: 36px !important;
  }
  .trashIcon {
    width: 14px !important;
    height: 16px !important;
    cursor: pointer;
    &:hover{
      color: red;
    }
  }
  .styledImage {
    width: 38px !important;
    height: 38px !important;
    border-radius: 6px;
  }
  .imageContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px !important;
    height: 38px !important;
    border-radius: 6px; 
    border: 2px solid;
    border-color: white;
    overflow: hidden;
  }
`;
const Popup = styled.div`
  width: 376px !important;
`;
